<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref, watch } from 'vue'
import _, { isNumber } from 'lodash'
import ContractDetailPage from '@/modules/contract/views/ContractDetailPage.vue'
import { useContractDetailStore } from '@/modules/contract/stores/contract.detail.store.ts'
import { useReactiveQueryParam } from '@/composables/useReactiveQueryParam.ts'
import {
  ContractCommissionListActionTypes,
  useContractCommissionList
} from '@/modules/contract/stores/contract.commission.list.store.ts'
import { useToast } from 'primevue/usetoast'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'


const router = useRouter()
const commissionListStore = useContractCommissionList()
const listingDetailStore = useContractDetailStore()


const pageTabs = computed(() => {
  return commissionListStore.tabs
})
const displayTabContent = computed(() => {
  return commissionListStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return commissionListStore.tableConfig
})
const filter = computed(() => {
  return commissionListStore.filter
})
const loading = computed(() => {
  return commissionListStore.action_type == ContractCommissionListActionTypes.FETCHING
})
const page = computed(() => {
  return commissionListStore.page
})
const pageSize = computed(() => {
  return commissionListStore.pageSize
})
const dataSource = computed(() => {
  return commissionListStore.data
})

const selectedIds = ref<number[]>([]);

const handleChangeTab = (tab: any) => {

  commissionListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  commissionListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  commissionListStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  commissionListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  commissionListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  commissionListStore.setFilter(filter)
}

const handleRowDblClick = (e: MouseEvent, item: any) => {

  commissionListStore.newTab({id: item.id, label: `#${item.code}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<number>) => {
  console.log(ids)
  selectedIds.value = ids
}

const paidProgress = ref<boolean>(false)
const toast = useToast()
const handlePaidCommission = async () => {
    if(selectedIds.value.length > 0 && !paidProgress.value) {
      try{
        const res = await APIClient.post('/commissions/paid', {
          ids: selectedIds.value,
        })
        toast.add({ severity: 'success', summary: 'Thành công!', detail: `Cập nhật trạng thái chi trả thành công`, life: 2000});
        requestFetchAccountList()
      } catch (e) {
        console.error(e)
        toast.add({ severity: 'error', summary: 'Thất bại', detail: `Cập nhật trạng thái chi trả thất bại`, life: 2000 });
      }
    }
}

const handleSort = (field: string, direction: string) => {

  commissionListStore.toggleSort(field, direction)
}

const requestFetchAccountList = _.debounce(async () => {
  try{
    const res = await commissionListStore.fetchList()
  } catch (e) {

  }
}, 500)

const detailId = useReactiveQueryParam('detailId')
const setDetailTab = async () => {
  if(parseInt(detailId.value || 0)){
    try {
      const data = await listingDetailStore.fetchDetail(parseInt(detailId.value))
      commissionListStore.newTab({id: data.id, label: `#${data.code}`, active: true})
    } catch (e: any) {

    }
  }
}


watch(()=> commissionListStore.uuid, (newVal, oldVal) => {
  requestFetchAccountList()
})

onMounted(() => {
  requestFetchAccountList()
  commissionListStore.changeTab('list')
  // if(detailId) setDetailTab()
})

watch(()=>detailId, (val) => {

  if(val.value) setDetailTab()
}, {immediate: true})
</script>

<template>
  <dashboard-layout currentRoute="commission/list" page-title="Quản lý hoa hồng" :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
      />
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource?.list || []"
        :buttons="[
          {
            selectRequired: true,
            label: 'Chi trả',
            icon: 'gridicons:create',
            class: 'btn bg-[#00a325] hover:bg-[#00841d] text-white',
            action: ()=>handlePaidCommission(),
            perm: 'contract.create',
          },
        ]"
        primaryField="id"
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="commissionListStore.toggleColumnVisibility"
        @on-selected-row="handleChangeSelectedRow"
        @on-sort="handleSort"

      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <panel :key="tab.id">
            <contract-detail-page :contract-id="tab.id"/>
          </panel>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
